<form [formGroup]="form" class="example-form">
<mat-form-field appearance="outline" class="matFormField text-autocomplete" panelWidth="auto" width="100%">
    <mat-label class="">{{field.label}}</mat-label>
    <input matInput #ref [formControlName]="field.control" readonly placeholder="MM/DD/YYYY" [attr.arialabel]="field.label" [matDatepicker]="picker">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
</form>
